import { appSaga } from "modules/app";
import { authSaga } from "modules/auth";
import { facilityOptionsSaga } from "modules/facility-options";
import { memberSaga } from "modules/member";
import { messageSaga } from "modules/message";
import { all } from "redux-saga/effects";

export default function* rootSaga() {
  yield all([authSaga(), messageSaga(), appSaga(), memberSaga(), facilityOptionsSaga()]);
}
